export default {
  title: 'Historia edycji menu',
  subtitle: 'Sprawdź, kto i kiedy zmienił ceny, dostępność i widoczność dla {{company}}.',
  filters: {
    type: {
      label: 'Typ',
    },
    item: {
      placeholder: 'Wszystkie pozycje',
    },
    event: {
      label: 'Zdarzenie',
    },
  },
  columns: {
    when: 'Kiedy',
    who: 'Zmienił(a)',
    type: 'Typ',
    item: 'Pozycja',
    event: 'Zdarzenie',
    changes: 'Zmiany',
  },
  types: {
    product: 'Produkt',
    modifier: 'Modyfikator',
  },
  events: {
    created: 'Utworzono',
    updated: 'Zaktualizowano',
    deleted: 'Usunięto',
  },
  fields: {
    name: 'Nazwa',
    description: 'Opis',
    price: 'Cena',
    is_available: 'Dostępność',
    is_visible: 'Widoczność',
    is_available_for_pickup: 'Dostępność odbioru',
    is_available_for_delivery: 'Dostępność dostawy',
  },
  booleans: {
    on: 'Dostępne',
    off: 'Niedostępne',
  },
  pagination: {
    previous: 'Poprzedni',
    next: 'Następny',
  },
  causers: {
    orders_terminal: 'Terminal zamówień',
  },
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Nie udało się załadować historii edycji menu',
  },
};
